import { observer } from 'mobx-react-lite';
import type { WeekAvailability } from '../../../types/availability';
import { TimeGridEntry } from '../../AvailabilityMatrix/AvailabilityMatrix';
import { TimetableVersionTableType } from '../graphql/types';
import { useVersionAvailability } from '../hooks/useVersionAvailability';
import { ResourceAvailabilityMatrix } from './ResourceAvailabilityMatrix';

type TimetableVersionRoomsMatrixProps = {
  selected: TimetableVersionTableType | null;
  versionUuid?: string | null;
  timeGridEntries: TimeGridEntry[];
  loading: boolean;
  onChange: (availability: WeekAvailability) => void;
};

export const TimetableVersionRoomsMatrix = observer(
  ({ selected, versionUuid, timeGridEntries, loading, onChange }: TimetableVersionRoomsMatrixProps) => {
    const { availability, fetching, execute } = useVersionAvailability(versionUuid, 'room', selected?.uuid);
    return (
      <ResourceAvailabilityMatrix
        availability={availability}
        timeGridEntries={timeGridEntries}
        loading={loading}
        fetching={fetching}
        onChange={onChange}
        execute={execute}
      />
    );
  },
);
